import { render, staticRenderFns } from "./ScanTestTubeLog.vue?vue&type=template&id=054abfdc&scoped=true"
import script from "./ScanTestTubeLog.vue?vue&type=script&lang=js"
export * from "./ScanTestTubeLog.vue?vue&type=script&lang=js"
import style0 from "./ScanTestTubeLog.vue?vue&type=style&index=0&id=054abfdc&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054abfdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054abfdc')) {
      api.createRecord('054abfdc', component.options)
    } else {
      api.reload('054abfdc', component.options)
    }
    module.hot.accept("./ScanTestTubeLog.vue?vue&type=template&id=054abfdc&scoped=true", function () {
      api.rerender('054abfdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationRecord/scanTestTubeLog/ScanTestTubeLog.vue"
export default component.exports